if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      // Toggle element kontrolü
      if (!this.toggle) {
        // Mobile toggle yoksa sessizce çık (normal durum olabilir)
        return;
      }

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      
      const mobileToggle = this.toggle.querySelector('.mobile-toggle');
      if (mobileToggle) {
        mobileToggle.addEventListener('click', (e) => {
          if (this.toggle.classList.contains('active')) {
            e.preventDefault();
            document.body.classList.remove('overflow-hidden');
            this.toggle.classList.remove('active');
            this.closeAnimation(this.toggle);
          } else {
            document.body.classList.add('overflow-hidden');
            setTimeout(() => {
              this.toggle.classList.add('active');
            });
          }
        });
      }

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      
      // Cart update listener
      document.addEventListener('cart:updated', (event) => {
        console.log('Header received cart:updated event:', event.detail);
        this.updateCartDisplay(event.detail.itemCount);
      });
      
      // Cart item remove button listeners
      this.attachCartRemoveListeners();
      
      // Buttons.
      if (this.menu) {
        this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
      }
    }
    
    attachCartRemoveListeners() {
      // İlk yükleme için
      attachRemoveButtonListeners();
      
      // DOM değişikliklerini dinle (yeni ürünler eklendiğinde)
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                const newRemoveButtons = node.querySelectorAll('.cart-item-remove');
                if (newRemoveButtons.length > 0) {
                  attachRemoveButtonListeners();
                }
              }
            });
          }
        });
      });
      
      // Cart tooltip içeriğini gözlemle
      const cartTooltip = document.querySelector('.tooltip-content');
      if (cartTooltip) {
        observer.observe(cartTooltip, {
          childList: true,
          subtree: true
        });
      }
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
      this.submenus = this.querySelectorAll('.thb-full-menu > .menu-item-has-children:not(.menu-item-has-megamenu) > .sub-menu');
    }

    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;

      // Resize on initial load
      document.fonts.ready.then(() => {
        window.addEventListener('resize', debounce(() => {
          _this.resizeSubMenus();
        }, 100));
      });
    }

    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        const subSubmenus = submenu.querySelectorAll(':scope > .menu-item-has-children > .sub-menu');

        subSubmenus.forEach((subSubmenu) => {
          const submenuRect = subSubmenu.getBoundingClientRect();
          const submenuRightEdge = submenuRect.left + submenuRect.width;
          const submenuIsOverflowing = submenuRightEdge > window.innerWidth;

          if (submenuIsOverflowing) {
            subSubmenu.parentElement.classList.add('left-submenu');
          } else {
            subSubmenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }

  customElements.define('full-menu', FullMenu);
}

// Language selector functionality
document.addEventListener('DOMContentLoaded', function() {
  const languageButton = document.querySelector('.language-selector__button');
  const languageList = document.querySelector('.language-selector__list');
  const languageLinks = document.querySelectorAll('.language-selector__link');

  if (languageButton && languageList) {
    languageButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isExpanded = languageButton.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        languageButton.setAttribute('aria-expanded', 'false');
        languageList.classList.remove('show');
      } else {
        languageButton.setAttribute('aria-expanded', 'true');
        languageList.classList.add('show');
      }
    });

    // Close language selector when clicking outside
    document.addEventListener('click', function(event) {
      if (!event.target.closest('.language-selector')) {
        languageButton.setAttribute('aria-expanded', 'false');
        languageList.classList.remove('show');
      }
    });

    // Handle language selection
    languageLinks.forEach(link => {
      link.addEventListener('click', function(event) {
        // Form submit will happen automatically since it's a submit button
        // No need to prevent default or manually submit
      });
    });
  }
});

// Search area expansion and predictive search
document.addEventListener('DOMContentLoaded', function() {
  const searchArea = document.querySelector('.search-area');
  const searchForm = document.querySelector('.search-form');
  const searchInput = searchForm.querySelector('.search-input');
  const predictiveSearch = searchForm.querySelector('.predictive-search');
  const loadingState = predictiveSearch.querySelector('.predictive-search__loading-state');
  const resultsContainer = predictiveSearch.querySelector('.predictive-search__results');

  searchInput.addEventListener('focus', function() {
    searchArea.classList.add('expanded');
  });

  searchInput.addEventListener('blur', function() {
    if (!predictiveSearch.contains(document.activeElement)) {
      searchArea.classList.remove('expanded');
    }
  });

  // Search input event handler
  searchInput.addEventListener('input', debounce((event) => {
    const searchTerm = event.target.value.trim();
    
    if (searchTerm.length > 0) {
      showLoading();
      performSearch(searchTerm);
    } else {
      hideResults();
    }
  }, 300));

  // Click outside to close search results
  document.addEventListener('click', function(e) {
    if (!searchForm.contains(e.target)) {
      hideResults();
    }
  });

  function showLoading() {
    predictiveSearch.hidden = false;
    loadingState.hidden = false;
    resultsContainer.hidden = true;
  }

  function hideResults() {
    predictiveSearch.hidden = true;
    loadingState.hidden = true;
    resultsContainer.hidden = true;
  }

  function performSearch(searchTerm) {
    fetch(`/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product`)
      .then(response => response.json())
      .then(suggestions => {
        loadingState.hidden = true;
        resultsContainer.hidden = false;
        
        const products = suggestions.resources.results.products;
        displaySearchResults(products, searchTerm);
      })
      .catch(error => {
        console.error('Error fetching search results:', error);
        hideResults();
      });
  }

  function displaySearchResults(results, searchTerm) {
    if (!results || results.length === 0) {
      resultsContainer.innerHTML = `
        <div class="predictive-search__no-results">
          <p>"${searchTerm}" için ürün bulunamadı</p>
          <div class="predictive-search__suggestions">
            <strong>Öneriler:</strong>
            <ul>
              <li>Farklı anahtar kelimeler deneyin</li>
              <li>Daha genel terimler kullanın</li>
              <li>Yazım hatası olup olmadığını kontrol edin</li>
            </ul>
          </div>
        </div>
      `;
    } else {
      resultsContainer.innerHTML = results.map(product => `
        <a href="${product.url}" class="predictive-search__item">
          <img src="${product.image || product.featured_image}" alt="${product.title}" class="predictive-search__item-image">
          <div class="predictive-search__item-info">
            <h4 class="predictive-search__item-title">${product.title}</h4>
            <div class="predictive-search__item-price">
              ${formatPrice(product.price, product.compare_at_price_max)}
            </div>
          </div>
        </a>
      `).join('');
    }
  }

  // Format price for display
  function formatPrice(price, compareAtPrice = null) {
    const formattedPrice = new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 2
    }).format(price);

    if (compareAtPrice && compareAtPrice > price) {
      const formattedComparePrice = new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2
      }).format(compareAtPrice);
      return `<span class="compare-at-price">${formattedComparePrice}</span><span class="final-price">${formattedPrice}</span>`;
    }

    return `<span class="final-price">${formattedPrice}</span>`;
  }

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // User Actions Tooltip Management
  const userActionItems = document.querySelectorAll('.user-action-item');
  const tooltips = document.querySelectorAll('.user-action-tooltip');
  
  // Tooltip pozisyonlama fonksiyonu
  function positionTooltip(tooltipWrapper) {
    if (!tooltipWrapper) return;
    
    const tooltip = tooltipWrapper.querySelector('.user-action-tooltip');
    if (!tooltip) return;
    
    // Ekran boyutları kontrolü
    const viewportWidth = window.innerWidth;
    const isMobile = viewportWidth <= 768;
    const isSmallScreen = viewportWidth <= 1400;
    
    // Tooltip'in boyutlarını al
    const tooltipRect = tooltip.getBoundingClientRect();
    const wrapperRect = tooltipWrapper.getBoundingClientRect();
    
    // Ekran boyutlarını al
    const viewportHeight = window.innerHeight;
    
    // Önceki pozisyon class'larını temizle
    tooltipWrapper.classList.remove('tooltip-left', 'tooltip-right', 'tooltip-bottom', 'tooltip-mobile');
    
    // Mobil cihazlarda özel pozisyonlama
    if (isMobile) {
      tooltipWrapper.classList.add('tooltip-mobile');
      return;
    }
    
    // Küçük ekranlarda (1400px'den küçük) sağa hizala
    if (isSmallScreen) {
      tooltipWrapper.classList.add('tooltip-right');
      return;
    }
    
    // Büyük ekranlarda dinamik pozisyonlama
    // Tooltip'in pozisyonunu hesapla
    const tooltipLeft = wrapperRect.left + (wrapperRect.width / 2) - (tooltipRect.width / 2);
    const tooltipRight = tooltipLeft + tooltipRect.width;
    const tooltipBottom = wrapperRect.bottom + tooltipRect.height;
    
    // Sol sınır kontrolü
    if (tooltipLeft < 10) {
      tooltipWrapper.classList.add('tooltip-left');
    }
    
    // Sağ sınır kontrolü
    if (tooltipRight > viewportWidth - 10) {
      tooltipWrapper.classList.add('tooltip-right');
    }
    
    // Alt sınır kontrolü
    if (tooltipBottom > viewportHeight - 20) {
      tooltipWrapper.classList.add('tooltip-bottom');
    }
    
    // Son kontrol: Tooltip'in genişliği viewport'tan büyükse
    if (tooltipRect.width > viewportWidth - 20) {
      tooltipWrapper.classList.add('tooltip-left');
    }
  }
  
  // Tüm tooltip'leri pozisyonla
  function positionAllTooltips() {
    tooltips.forEach(tooltip => {
      const wrapper = tooltip.closest('.tooltip-wrapper');
      if (wrapper) {
        positionTooltip(wrapper);
      }
    });
  }
  
  // Sayfa yüklendiğinde ve resize olduğunda tooltip'leri pozisyonla
  document.addEventListener('DOMContentLoaded', positionAllTooltips);
  window.addEventListener('resize', debounce(positionAllTooltips, 250));
  
  // Tooltip hover olduğunda pozisyonla
  userActionItems.forEach(item => {
    const tooltipWrapper = item.querySelector('.tooltip-wrapper');
    if (tooltipWrapper) {
      item.addEventListener('mouseenter', () => {
        // Kısa bir gecikme ile pozisyonla (tooltip görünür olduktan sonra)
        setTimeout(() => {
          positionTooltip(tooltipWrapper);
        }, 50);
      });
    }
  });
  
  // Prevent tooltips from closing when clicking inside them
  tooltips.forEach(tooltip => {
    tooltip.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });

  // Handle mobile tap functionality
  userActionItems.forEach(item => {
    const link = item.querySelector('.user-action-link');
    const tooltip = item.querySelector('.user-action-tooltip');
    
    if (link && tooltip) {
      // Mobile tap handling
      link.addEventListener('click', function(e) {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          
          // Close other tooltips
          userActionItems.forEach(otherItem => {
            if (otherItem !== item) {
              const otherTooltipWrapper = otherItem.querySelector('.tooltip-wrapper');
              if (otherTooltipWrapper) {
                otherTooltipWrapper.classList.remove('show');
              }
            }
          });
          
          // Toggle current tooltip
          const tooltipWrapper = item.querySelector('.tooltip-wrapper');
          if (tooltipWrapper) {
            const isVisible = tooltipWrapper.classList.contains('show');
            if (isVisible) {
              tooltipWrapper.classList.remove('show');
            } else {
              tooltipWrapper.classList.add('show');
              // Attach remove button listeners when cart tooltip is shown
              if (item.querySelector('.cart-tooltip')) {
                setTimeout(() => {
                  attachRemoveButtonListeners();
                }, 100);
              }
            }
          }
        }
      });
    }
  });

  // Initialize page
  console.log('Header functionality initialized');
});

// Cart functionality for real-time updates
document.addEventListener('DOMContentLoaded', function() {
  const cartLink = document.querySelector('.user-action-link[href*="/cart"]');
  
  // Listen for cart updates
  document.addEventListener('cart:updated', function(event) {
    updateCartDisplay(event.detail);
  });

  // Listen for cart add events
  document.addEventListener('cart:added', function(event) {
    updateCartDisplay(event.detail);
    showCartTooltip();
  });

  function updateCartDisplay(cartData) {
    console.log('Header updateCartDisplay called with:', cartData);
    
    let itemCount;
    if (typeof cartData === 'number') {
      itemCount = cartData;
    } else if (cartData && cartData.item_count !== undefined) {
      itemCount = cartData.item_count;
    } else {
      console.log('Invalid cart data:', cartData);
      return;
    }
    
    console.log('Header updating cart display with count:', itemCount);
    
    // Update cart count in header
    const cartTextElements = document.querySelectorAll('.user-action-text');
    cartTextElements.forEach(element => {
      if (element.textContent.includes('Sepet')) {
        console.log('Header updating cart element:', element.textContent, '→', `Sepet (${itemCount})`);
        element.textContent = `Sepet (${itemCount})`;
      }
    });

    // Update cart tooltip content
    const cartTooltip = document.querySelector('.cart-tooltip');
    if (cartTooltip) {
      if (itemCount == 0) {
        cartTooltip.innerHTML = `
          <div class="tooltip-content empty-state">
            <div class="empty-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="currentColor" class="bi bi-bag" viewBox="0 0 16 16">
                  <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"></path>
                </svg>
            </div>
            <p class="empty-message">Şu anda sepetinizde ürün bulunmuyor</p>
            <button class="shop-button" onclick="window.location.href='/collections/new-arrivals'">YENİ ÜRÜNLERİ KEŞFET</button>
          </div>
        `;
      } else {
        cartTooltip.innerHTML = `
          <div class="tooltip-content cart-items">
            <div class="cart-header">
              <h3>Sepetim (${itemCount})</h3>
            </div>
            <div class="cart-items-list">
              ${cartData.items.map(item => `
                <div class="cart-item" data-item-key="${item.key || ''}">
                  <img src="${item.image || ''}" alt="${item.title || item.product_title || 'Ürün'}" class="cart-item-image" width="50" height="50">
                  <div class="cart-item-info">
                    ${item.vendor && item.vendor !== 'null' ? `<p class="cart-item-brand">${item.vendor}</p>` : ''}
                    <h4 class="cart-item-title">${item.product_title || item.title || 'Ürün'}</h4>
                    ${item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'null' ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
                    <p class="cart-item-quantity">Adet: ${item.quantity || 1}</p>
                    <p class="cart-item-price">${formatMoney(item.final_price || item.price || 0)}</p>
                  </div>
                  <button class="cart-item-remove" 
                          data-item-key="${item.key || ''}" 
                          aria-label="Ürünü sepetten çıkar">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              `).join('')}
            </div>
            <div class="cart-total">
              <p><strong>Toplam: ${formatMoney(cartData.total_price || 0)}</strong></p>
            </div>
            <div class="cart-actions">
              <button class="checkout-button" onclick="window.location.href='/cart'">SEPETE GİT</button>
            </div>
          </div>
        `;
      }
    }
  }

  // updateCartTooltipContent function is now global

  // showCartTooltip function is now global

  // formatMoney function is now global

  // Initial attachment of remove button listeners
  attachRemoveButtonListeners();
  
  // Also attach listeners after a short delay to ensure DOM is ready
  setTimeout(() => {
    attachRemoveButtonListeners();
  }, 500);
  
  // Test function to manually show cart tooltip
  window.testCartTooltip = function() {
    console.log('Testing cart tooltip manually...');
    showCartTooltip();
  };
  
  // Test function to manually update cart content
  window.testCartUpdate = function() {
    console.log('Testing cart update manually...');
    fetch('/cart.js')
      .then(response => response.json())
      .then(cartData => {
        console.log('Manual cart data:', cartData);
        updateCartTooltipContent(cartData);
        showCartTooltip();
      });
  };
});

// Global functions for cart functionality
function updateCartCount(count) {
  // Ensure count is a valid number
  const validCount = parseInt(count) || 0;
  
  console.log('Updating cart count to:', validCount);
  
  const cartTextElements = document.querySelectorAll('.user-action-text');
  cartTextElements.forEach(element => {
    if (element.textContent.includes('Sepet')) {
      const currentText = element.textContent;
      const newText = `Sepet (${validCount})`;
      element.textContent = newText;
      console.log('Cart text updated from:', currentText, 'to:', newText);
    }
  });
}

function showCartTooltip() {
  console.log('Showing cart tooltip...');
  
  const cartItems = document.querySelectorAll('.user-action-item');
  console.log('Found user-action-items:', cartItems.length);
  
  let tooltipWrapper = null;
  let cartItem = null;
  
  // Find the cart item that contains cart-tooltip
  cartItems.forEach((item, index) => {
    console.log(`Checking item ${index}:`, item);
    if (item.querySelector('.cart-tooltip')) {
      tooltipWrapper = item.querySelector('.tooltip-wrapper');
      cartItem = item;
      console.log('Found cart tooltip in item:', index);
    }
  });
  
  if (tooltipWrapper && cartItem) {
    // Add show class to trigger CSS animations
    tooltipWrapper.classList.add('show');
    
    // Tooltip pozisyonunu tekrar ayarla
    setTimeout(() => {
      positionTooltip(tooltipWrapper);
    }, 50);
    
    console.log('Cart tooltip shown successfully');
    
    // Auto-hide after 5 seconds
    setTimeout(() => {
      tooltipWrapper.classList.remove('show');
      console.log('Cart tooltip hidden after timeout');
    }, 5000);
  } else {
    console.log('Cart tooltip wrapper not found');
    console.log('tooltipWrapper:', tooltipWrapper);
    console.log('cartItem:', cartItem);
  }
}

function formatMoney(cents) {
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    minimumFractionDigits: 2
  }).format(cents / 100);
}

function updateCartTooltipContent(cartData) {
  console.log('Updating cart tooltip content with data:', cartData);
  
  const cartItems = document.querySelectorAll('.user-action-item');
  let tooltipContent = null;
  let tooltipWrapper = null;
  
  // Find the cart tooltip content
  cartItems.forEach(item => {
    if (item.querySelector('.cart-tooltip')) {
      tooltipContent = item.querySelector('.tooltip-content');
      tooltipWrapper = item.querySelector('.tooltip-wrapper');
    }
  });
  
  if (!tooltipContent) {
    console.log('Tooltip content not found');
    return;
  }
  
  if (cartData.item_count === 0) {
    tooltipContent.className = 'tooltip-content empty-state';
    tooltipContent.innerHTML = `
      <div class="empty-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="currentColor" class="bi bi-bag" viewBox="0 0 16 16">
            <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"></path>
        </svg>
      </div>
      <p class="empty-message">Şu anda sepetinizde ürün bulunmuyor</p>
      <button class="shop-button" onclick="window.location.href='/collections/new-arrivals'">YENİ ÜRÜNLERİ KEŞFET</button>
    `;
  } else {
    tooltipContent.className = 'tooltip-content cart-items';
    tooltipContent.innerHTML = `
      <div class="cart-header">
        <h3>Sepetim (${cartData.item_count})</h3>
      </div>
      <div class="cart-items-list">
        ${cartData.items.slice(0, 3).map(item => `
          <div class="cart-item" data-item-key="${item.key || ''}">
            <img src="${item.image || ''}" alt="${item.title || item.product_title || 'Ürün'}" class="cart-item-image" width="50" height="50">
            <div class="cart-item-info">
              ${item.vendor && item.vendor !== 'null' ? `<p class="cart-item-brand">${item.vendor}</p>` : ''}
              <h4 class="cart-item-title">${item.product_title || item.title || 'Ürün'}</h4>
              ${item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'null' ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
              <p class="cart-item-quantity">Adet: ${item.quantity || 1}</p>
              <p class="cart-item-price">${formatMoney(item.final_price || item.price || 0)}</p>
            </div>
            <button class="cart-item-remove" 
                    data-item-key="${item.key || ''}" 
                    aria-label="Ürünü sepetten çıkar">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        `).join('')}
      </div>
      <div class="cart-total">
        <p><strong>Toplam: ${formatMoney(cartData.total_price || 0)}</strong></p>
      </div>
      <div class="cart-actions">
        <button class="checkout-button" onclick="window.location.href='/cart'">SEPETE GİT</button>
      </div>
    `;
    
    // Re-attach remove button event listeners for new items
    setTimeout(() => {
      attachRemoveButtonListeners();
    }, 50);
  }
  
  // Tooltip pozisyonunu güncelle
  if (tooltipWrapper) {
    setTimeout(() => {
      positionTooltip(tooltipWrapper);
    }, 100);
  }
  
  // Also attach listeners when tooltip is shown
  setTimeout(() => {
    attachRemoveButtonListeners();
  }, 100);
}

function attachRemoveButtonListeners() {
  const cartRemoveButtons = document.querySelectorAll('.cart-item-remove');
  
  console.log('Attaching remove button listeners to', cartRemoveButtons.length, 'buttons');
  
  cartRemoveButtons.forEach(button => {
    // Remove existing listeners to prevent duplicates
    button.removeEventListener('click', handleRemoveClick);
    button.addEventListener('click', handleRemoveClick);
    console.log('Added click listener to remove button:', button);
  });
}

async function handleRemoveClick(e) {
  e.preventDefault();
  e.stopPropagation();
  
  const button = e.currentTarget;
  const itemKey = button.getAttribute('data-item-key');
  const cartItem = button.closest('.cart-item');
  
  console.log('Remove button clicked for item:', itemKey);
  console.log('Cart item element:', cartItem);
  
  if (!itemKey) {
    console.log('No item key found');
    return;
  }
  
  // Disable button and show loading
  button.disabled = true;
  button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 2V6M12 18V22M4.93 4.93L7.76 7.76M16.24 16.24L19.07 19.07M2 12H6M18 12H22M4.93 19.07L7.76 16.24M16.24 7.76L19.07 4.93" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  
  try {
    console.log('Fetching cart data...');
    // Önce cart.js'den mevcut sepet verilerini al
    const cartResponse = await fetch('/cart.js');
    console.log('Cart response status:', cartResponse.status);
    
    if (!cartResponse.ok) {
      throw new Error(`Cart fetch failed: ${cartResponse.status}`);
    }
    
    const cartData = await cartResponse.json();
    console.log('Cart data received:', cartData);
    console.log('Cart items:', cartData.items);
    
    // itemKey'den doğru variant ID'sini bul
    const cartItemData = cartData.items.find(item => item.key === itemKey);
    console.log('Looking for item with key:', itemKey);
    console.log('Found cart item:', cartItemData);
    
    if (!cartItemData) {
      console.log('Item not found in cart, trying alternative method...');
      // Alternatif yöntem: doğrudan itemKey kullan
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      });
      
      if (response.ok) {
        const updatedCartData = await response.json();
        console.log('Cart updated with itemKey method:', updatedCartData);
        await handleCartUpdate(updatedCartData, cartItem);
        return;
      } else {
        throw new Error('Alternative method also failed');
      }
    }
    
    console.log('Variant ID:', cartItemData.variant_id);
    
    // Doğrudan Shopify cart API'sini kullan - key ile
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: cartItemData.key, // variant_id yerine key kullan
        quantity: 0
      })
    });
    
    console.log('Remove response status:', response.status);
    
    if (response.ok) {
      const updatedCartData = await response.json();
      console.log('Cart updated after remove:', updatedCartData);
      await handleCartUpdate(updatedCartData, cartItem);
    } else {
      const errorText = await response.text();
      console.error('Remove failed with status:', response.status);
      console.error('Error response:', errorText);
      throw new Error(`Remove failed: ${response.status} - ${errorText}`);
    }
    
  } catch (error) {
    console.error('Sepet güncelleme hatası:', error);
    console.error('Error details:', error.message);
    alert('Ürün sepetten çıkarılırken bir hata oluştu. Lütfen tekrar deneyin.');
    
    // Restore button
    button.disabled = false;
    button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
}

async function handleCartUpdate(updatedCartData, cartItem) {
  // Update cart count
  const cartTextElements = document.querySelectorAll('.user-action-text');
  cartTextElements.forEach(element => {
    if (element.textContent.includes('Sepet')) {
      element.textContent = `Sepet (${updatedCartData.item_count})`;
    }
  });
  
  // Remove item from DOM with animation
  if (cartItem) {
    cartItem.style.opacity = '0.5';
    setTimeout(() => {
      cartItem.remove();
      
      // Update cart tooltip content
      if (updatedCartData.item_count === 0) {
        updateCartTooltipContent(updatedCartData);
      } else {
        // Update total price
        const cartTotalElement = document.querySelector('.cart-total strong');
        if (cartTotalElement) {
          cartTotalElement.textContent = `Toplam: ${formatMoney(updatedCartData.total_price)}`;
        }
      }
      
      // Re-attach remove button listeners after DOM update
      setTimeout(() => {
        attachRemoveButtonListeners();
      }, 100);
      
      // Dispatch cart update event
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: updatedCartData
      }));
    }, 300);
  }
  
  // Dispatch cart update event
  document.dispatchEvent(new CustomEvent('cart:updated', {
    detail: updatedCartData
  }));
}



// Intercept form submissions to handle cart updates
document.addEventListener('DOMContentLoaded', function() {
  // Listen for all form submissions
  document.addEventListener('submit', function(event) {
    const form = event.target;
    
    // Check if this is a cart add form
    console.log('Form submitted:', form);
    console.log('Form action:', form.action);
    console.log('Form action attribute:', form.getAttribute('action'));
    console.log('Form id:', form.id);
    console.log('Form classes:', form.className);
    
    if (form.action && form.action.includes('/cart/add') || 
        form.getAttribute('action') && form.getAttribute('action').includes('/cart/add') ||
        form.id && form.id.includes('cart') ||
        form.classList.contains('cart-form') ||
        form.classList.contains('product-form') ||
        form.querySelector('input[name="id"]') ||
        form.querySelector('select[name="id"]')) {
      event.preventDefault();
      
      const formData = new FormData(form);
      
      console.log('Sending form data to cart/add.js');
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        console.log('Cart add response status:', response.status);
        return response.json();
      })
      .then(data => {
        console.log('Product added to cart:', data);
        
        // Don't update count immediately from add.js response
        // Wait for cart.js response instead
        
        // Trigger cart update event
        document.dispatchEvent(new CustomEvent('cart:added', {
          detail: data
        }));
        
        // Get updated cart data
        console.log('Fetching updated cart data from /cart.js');
        return fetch('/cart.js');
      })
      .then(response => {
        console.log('Cart.js response status:', response.status);
        return response.json();
      })
      .then(cartData => {
        console.log('Cart updated:', cartData);
        console.log('Cart items:', cartData.items);
        console.log('Cart item count:', cartData.item_count);
        
        // Update cart count from cart.js API - this has the correct total
        const cartItemCount = cartData.item_count || 0;
        updateCartCount(cartItemCount);
        
        // Update cart tooltip content with new data
        updateCartTooltipContent(cartData);
        
        // Show cart tooltip after successful update
        showCartTooltip();
        
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: cartData
        }));
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
    }
  });
  
  // Listen for cart updates from other sources
  document.addEventListener('cart:updated', function(event) {
    console.log('Cart update event received:', event.detail);
    // Don't update count here as it's already updated in the fetch chain
  });
  
  document.addEventListener('cart:added', function(event) {
    console.log('Cart add event received:', event.detail);
    // Don't update count here as it's already updated in the fetch chain
  });
});

// Persist top bar category selection across the site
document.addEventListener('DOMContentLoaded', function() {
  const topBarCategoryLinks = document.querySelectorAll('.top-bar-inner nav a[data-category]');

  function persistCategory(category) {
    if (!category) return;
    try { document.cookie = `preferred_category=${category}; path=/; max-age=31536000; SameSite=Lax`; } catch (err) {}
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { preferred_category: category } })
    }).catch(() => {});
  }

  // 1) Top bar click: persist then navigate
  if (topBarCategoryLinks && topBarCategoryLinks.length) {
    topBarCategoryLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        const category = link.getAttribute('data-category');
        if (!category) return;
        const href = link.getAttribute('href') || '/';
        e.preventDefault();
        persistCategory(category);
        window.location.href = href;
      });
    });
  }

  // 2) On page load: if URL matches /pages/kadin|erkek|cocuk|ev, persist automatically
  const path = (location.pathname || '').toLowerCase();
  let urlCategory = '';
  if (path.includes('/pages/kadin') || path.includes('/women')) urlCategory = 'women';
  else if (path.includes('/pages/erkek') || path.includes('/men')) urlCategory = 'men';
  else if (path.includes('/pages/cocuk') || path.includes('/kids')) urlCategory = 'kids';
  else if (path.includes('/pages/ev') || path.includes('/home')) urlCategory = 'home';
  if (urlCategory) persistCategory(urlCategory);

});
